<template>
	<ea-action v-if="visible" :meta="eaMetaInfo" :class="clazz" :style="style"><icon-button :name="eaIcon" :class="iconClass"></icon-button></ea-action>
</template>

<script setup lang="ts">
import {computed} from "vue";
import useEditor, {type EditorProps, editorProps} from "@fd/editors/Editor.ts";
import {type EaAction as EaActionPartType} from "@t/fd/editor/EAddress.ts";
import EaAction from "@fd/editors/eaddress/EaAction.vue";
import IconButton from "@fd/helpers/IconButton.vue";
import resolve, {EAMeta} from "@fd/editors/eaddress/EAResolver.ts";


const uprops = defineProps({...editorProps});
const props = uprops as EditorProps;

const ea = computed<EaActionPartType>(() => props.part as EaActionPartType);
const {visible, value, clazz, style} = useEditor(props);

const eaMetaInfo = computed((): EAMeta => {
	return resolve(value.value);
});
const eaIcon = computed(() => {
	return eaMetaInfo.value.icon;
});

const iconClass = computed(() => {
	const c = ["fd-ea-icon"];
	const m = eaMetaInfo.value;
	if (!m.ok) c.push("fd-ea-icon-warning");
	else if (m.empty) c.push("fd-ea-icon-empty");
	return c;
});
</script>

<style>

</style>